import script from "./advantage.vue?vue&type=script&setup=true&lang=js"
export * from "./advantage.vue?vue&type=script&setup=true&lang=js"

import "./advantage.vue?vue&type=style&index=0&id=446615a3&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446615a3"]])

export default __exports__